import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background-color: ${({ theme }) => theme.colors.secondary};
  padding: 3rem 0 2rem;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
`;

const FooterTitle = styled.h4`
  font-family: ${({ theme }) => theme.fonts.accent};
  color: ${({ theme }) => theme.colors.primary};
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
  font-weight: 500;
`;

const FooterLink = styled(Link)`
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 0.75rem;
  font-size: 0.9rem;
  transition: color 0.2s ease;
  
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

// const SocialLinks = styled.div`
//   display: flex;
//   gap: 1rem;
//   margin-top: 0.5rem;
// `;

// const SocialLink = styled.a`
//   color: ${({ theme }) => theme.colors.text};
//   font-size: 1.2rem;
//   transition: color 0.2s ease;
  
//   &:hover {
//     color: ${({ theme }) => theme.colors.primary};
//   }
// `;

const Copyright = styled.div`
  text-align: center;
  margin-top: 3rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  color: ${({ theme }) => theme.colors.lightText};
  font-size: 0.8rem;
`;

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <FooterTitle>Ajana Designs</FooterTitle>
          <p style={{ color: '#333', marginBottom: '1rem', fontSize: '0.9rem' }}>
            Exquisite handcrafted jewelry that celebrates elegance and individuality.
          </p>
          {/* <SocialLinks>
            <SocialLink href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </SocialLink>
            <SocialLink href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook-f"></i>
            </SocialLink>
            <SocialLink href="https://pinterest.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-pinterest-p"></i>
            </SocialLink>
          </SocialLinks> */}
        </FooterSection>
        
        <FooterSection>
          <FooterTitle>Shop</FooterTitle>
          <FooterLink to="/collections/necklaces">Necklaces</FooterLink>
          <FooterLink to="/collections/earrings">Earrings</FooterLink>
          <FooterLink to="/collections/rings">Rings</FooterLink>
        </FooterSection>
        
        <FooterSection>
          <FooterTitle>Information</FooterTitle>
          <FooterLink to="/">About Us</FooterLink>
          <FooterLink to="/">Contact</FooterLink>
          {/* <FooterLink to="/shipping">Shipping & Returns</FooterLink> */}
          {/* <FooterLink to="/care">Jewelry Care</FooterLink> */}
          {/* <FooterLink to="/faq">FAQ</FooterLink> */}
        </FooterSection>
      </FooterContent>
      
      <Copyright>
        © {currentYear} Ajana Designs. All rights reserved.
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;
